/**
 * Modal Component
 *
 * Generic modal dialog with auto-open delay and ARIA accessibility.
 *
 * Usage in Liquid:
 * <dialog x-data="modal"
 *         data-modal-id="my-modal"
 *         data-delay="{{ section.settings.delay }}">
 */

export default function modal() {
    return {
        autoOpen: false,
        delay: 0,
        modalId: 'dialog-modal',

        init() {
            const el = this.$el;
            this.modalId = el.dataset.modalId || 'dialog-modal';
            const delay = parseInt(el.dataset.delay) || 0;
            this.autoOpen = delay > 0;
            this.delay = delay * 1000;

            // Listen for custom namespaced event (e.g., 'show-modal-my-modal')
            document.addEventListener(`show-modal-${this.modalId}`, () => {
                this.open();
            });

            // Auto-open after delay if configured
            if (this.autoOpen) {
                setTimeout(() => {
                    this.open();
                }, this.delay);
            }
        },

        open() {
            // Use native dialog showModal() method
            this.$el.showModal();
        },

        close(event?: Event) {
            // Close unconditionally if no event, or if event targets the backdrop
            if (!event || event.target === this.$el) {
                this.$el.close();
            }
        },
    };
}
